// DS: i3.2
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
const Add = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
    }))));
Add.displayName = 'Add';
export default Add;

//# sourceMappingURL=Add.js.map